module.exports = __webpack_public_path__ + "img/navigate-icon.7bfc40fc.png";